import { createSelector } from "reselect";
import { resetPasswordSelector } from "../reset_password_selector";

export const resetPasswordLoadStateSelector = createSelector(
  resetPasswordSelector,
  resetPassword => {
    return resetPassword.loadState;
  }
);
